import React, { useState } from "react";

const ProductViewModal = ({ product, onClose }) => {
  const [activeImage, setActiveImage] = useState(0);

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl w-full max-w-3xl shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 bg-green-50 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800">Product Details</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500 transition"
          >
            ✕
          </button>
        </div>

        <div className="p-6">
          <div className="flex flex-col md:flex-row gap-6">
            {/* Images */}
            <div className="md:w-2/5">
              <div className="rounded-xl overflow-hidden h-60 bg-gray-100">
                <img
                  src={product.images?.[activeImage]}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Thumbnails */}
              {product.images?.length > 1 && (
                <div className="flex gap-2 mt-3 flex-wrap">
                  {product.images.map((img, i) => (
                    <button
                      key={i}
                      onClick={() => setActiveImage(i)}
                      className={`w-14 h-14 rounded-lg overflow-hidden border-2 transition ${
                        activeImage === i
                          ? "border-green-500"
                          : "border-gray-200"
                      }`}
                    >
                      <img
                        src={img}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Details */}
            <div className="flex-1 space-y-4">
              <div>
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-xl font-bold text-gray-800">
                    {product.name}
                  </h3>
                  {product.isTopProduct && (
                    <span className="bg-yellow-100 text-yellow-700 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      ⭐ Top Product
                    </span>
                  )}
                </div>
                <span className="inline-block mt-1 bg-green-100 text-green-700 text-xs font-medium px-2.5 py-1 rounded-full">
                  {product.category?.category}
                </span>
              </div>

              <div className="flex items-center gap-4">
                <span
                  className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                    product.stock > 0
                      ? "bg-green-50 text-green-600"
                      : "bg-red-50 text-red-500"
                  }`}
                >
                  {product.stock > 0
                    ? `In Stock (${product.stock})`
                    : "Out of Stock"}
                </span>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-2">
                <div className="flex">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span
                      key={i}
                      className={`text-lg ${i < product.rating ? "text-yellow-400" : "text-gray-200"}`}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <span className="text-sm text-gray-500">
                  ({product.reviewCount} reviews)
                </span>
              </div>

              <p className="text-sm text-gray-600 leading-relaxed">
                {product.description}
              </p>

              {/* Dosage */}
              {product.dosage && (
                <div className="bg-blue-50 rounded-lg px-4 py-3">
                  <p className="text-xs font-semibold text-blue-700 uppercase tracking-wide">
                    Dosage
                  </p>
                  <p className="text-sm text-blue-800 mt-0.5">
                    {product.dosage}
                  </p>
                </div>
              )}

              {/* Pack Sizes */}
              {product.packSizes?.length > 0 && (
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Pack Sizes
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {product.packSizes.map((size, i) => (
                      <span
                        key={i}
                        className="text-sm bg-gray-100 text-gray-700 px-3 py-1 rounded-full"
                      >
                        {size}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Recommended Crops */}
              {product.recommendedCrops?.length > 0 && (
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Recommended Crops
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {product.recommendedCrops.map((crop, i) => (
                      <span
                        key={i}
                        className="text-sm bg-green-50 text-green-700 px-3 py-1 rounded-full"
                      >
                        🌱 {crop}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductViewModal;
